import React from 'react';

interface ObjectListLoadingTableProps {
    columns: number;
    rows?: number;
}

export const ObjectListLoadingTable = (props: ObjectListLoadingTableProps) => {
    const columns = Array.from({ length: Math.max(props.columns, 1) });
    const rows = Array.from({ length: props.rows ?? 6 });

    return (
        <div
            role='status'
            aria-busy='true'
            className='w-full overflow-hidden'>
            <table className='w-full border-collapse text-left'>
                <thead className='outline-border-default h-12 outline-1'>
                    <tr>
                        {columns.map((_, index) => (
                            <th
                                key={index}
                                className='px-4 py-3'>
                                <div className='bg-border-default h-4 w-2/3 animate-pulse rounded' />
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((_, rowIndex) => (
                        <tr
                            key={rowIndex}
                            className='border-border-default border-b'>
                            {columns.map((_, columnIndex) => (
                                <td
                                    key={columnIndex}
                                    className='px-4 py-4'>
                                    <div
                                        className='bg-background-default h-4 animate-pulse rounded'
                                        style={{ width: `${columnIndex % 2 === 0 ? 70 : 90}%` }}
                                    />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
